export const environment = {
  appName: 'Handyhand',
  appUrl: 'https://handyhand.nl',
  country: 'Netherlands',
  platformUrl: 'http://localhost:4200',
  production: true,
  supportEmail: 'patrick@handyhand.nl',
  supportPhone: '+31 20 1234567',
  env: 'production',
  apiUrl: 'http://localhost:3000/api',
  apiV2Url: 'http://localhost:1234',
  vectorServiceUrl: 'https://vector.handyhand.dk/api',
  googleTagId: 'GTM-',
  dashboardBaseRef: 'http://localhost:9000/',
  apiPrefix: 'nl/',
  resizeUrl: 'https://d3r2zfg0xujt92.cloudfront.net',
  cloudFrontImgUrl: 'https://d10a6kin4dgxel.cloudfront.net',
  domain: 'https://handyhand.nl',
  posthog: {
    key: 'phc_CclftH2vXTL1AqhE3n7mxqYmPdHSHEcWdReQLIIOrMi',
    host: 'https://eu.i.posthog.com',
  },
  social: {
    fb: 'https://nl-nl.facebook.com/handyhand',
    instagram: 'https://www.instagram.com/handyhand.nl/',
    linkedin: 'https://nl.linkedin.com/company/handy-hand',
  },
};
